<template>
  <div>
    <BasicLayout :left="left" :middle="middle" :right="right">
      <template v-slot:left_view>
        <RealTaskManagement
          ref="realTaskManagement"
          @transferMeasureObj="transferMeasureObj"
          @transferNe="transferNe"
        ></RealTaskManagement>
      </template>
      <template v-slot:right_view>
        <RealTaskList ref="realTaskList" @createRealTaskAddTabEmit="createRealTaskAddTabEmit"></RealTaskList>
      </template>
    </BasicLayout>
  </div>
</template>

<script>
import BasicLayout from '../../../layouts/BasicLayout';
import RealTaskList from './RealTaskList';
import RealTaskManagement from './RealTaskManagement';

export default {
  name: 'RealTimeTaskPageContent',
  components: {
    BasicLayout,
    RealTaskList,
    RealTaskManagement
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t('Pm.exitTaskInfo')
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t('Pm.taskList')
      }
    };
  },
  methods: {
    createRealTaskAddTabEmit(args) {
      this.$refs.realTaskManagement.reloadTree();
      this.$emit('createRealTaskAddTabEmit', args);
    },
    transferMeasureObj(msg) {
      this.$refs.realTaskList.transferMeasureObjChildren(msg);
    },
    transferNe(msg) {
      this.$refs.realTaskList.transferNeChildren(msg);
    },
    // 刷新任务列表
    refreshGridForTaskListReal() {
      this.$refs.realTaskList.refreshGridForTaskListReal();
    }
  }
};
</script>

<style>
</style>
